
import React from 'react';
import './BanModal.css';

const BanModal = ({ isOpen, banInfo, onClose, t }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="ban-modal-container">
        <div className="ban-modal-content">
          <div className="ban-modal-header">
            <h2 className="ban-modal-title">
              {t('accountBanned')}
            </h2>
          </div>
          
          <div className="ban-modal-body">
            <div className="ban-icon">
              🚫
            </div>
            
            <p className="ban-description">
              {t('accountBannedDesc')}
            </p>
            
            {banInfo && (
              <div className="ban-details">
                <div className="ban-detail-item">
                  <strong>{t('bannedBy')}:</strong> {banInfo.bannedBy}
                </div>
                {banInfo.reason && (
                  <div className="ban-detail-item">
                    <strong>{t('reason')}:</strong> {banInfo.reason}
                  </div>
                )}
                {banInfo.date && (
                  <div className="ban-detail-item">
                    <strong>{t('date')}:</strong> {new Date(banInfo.date).toLocaleString()}
                  </div>
                )}
              </div>
            )}
            
            <p className="ban-contact">
              {t('contactSupport')}
            </p>
          </div>
          
          <div className="ban-modal-footer">
            <button 
              onClick={onClose}
              className="ban-modal-button"
            >
              {t('understood')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BanModal;